import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-patches/definition"
import {ImageOpExtractPatchesHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-patches/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

const nodeDefinition = {...Definition, nodeClass: "ImageOpNodeExtractPatches"}

@registerImageOpNode
export class ImageOpNodeExtractPatches extends BasicSpecializingImageOpNode<typeof Definition, ImageOpExtractPatchesHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof Definition>) {
        super(ImageOpExtractPatchesHal, parameters)
    }
}
